module.exports = __webpack_public_path__ + "static/media/background03.8aced18d.jpg";